import { Brand, Link } from '@farol-ds/react'
import { forwardRef, useContext } from 'react'

import { TopbarContext } from '../../context'
import styles from './topbar-brand.module.scss'

export const TopbarBrand = forwardRef(function TopbarBrand() {
  // Prefix with baseUrl so the logo points to www on apps rendered off the www
  // origin (e.g. profile subdomains); empty by default keeps it origin-relative.
  const { baseUrl } = useContext(TopbarContext)
  return (
    <Link href={`${baseUrl ?? ''}/`} aria-label="Voltar para página principal Jusbrasil">
      <Brand onlySymbol className={styles.brandSymbol} />
      <Brand className={styles.brand} />
    </Link>
  )
})
